import {
    RI_PUT_AWAY_INDEX_ROUTE,
    RI_PUT_AWAY_FINALIZED_INDEX_ROUTE,
    RI_PUT_AWAY_DETAILS_ROUTE,
} from '../../../modules/receiveInventory/consts';

import { PRODUCTS_DETAILS_ROUTE } from '../../../modules/products/consts';

export default {
    name: 'putAwayPage',
    before: [],
    after: [],
    setup: (app) => {
        const pageName = 'receiveInventoryPutAwayMain';
        const pageRoute = app.routes.getItem(pageName);

        if (pageRoute) {
            const pageRouteProps = pageRoute.props;

            pageRoute.props = (state) => ({
                ...pageRouteProps(state),
                routes: {
                    putAwayRoute: RI_PUT_AWAY_INDEX_ROUTE,
                    putAwayFinalRoute: RI_PUT_AWAY_FINALIZED_INDEX_ROUTE,
                    putAwayFinalDetailsRoute: RI_PUT_AWAY_DETAILS_ROUTE,
                    productDetailsPageRoute: PRODUCTS_DETAILS_ROUTE,
                },
                permissions: {
                    canAssignUser: true,
                    withProductLink: true,
                },
                modes: {
                    withQuantitySetModal: false,
                    withLocationAutoReset: false,
                    withIncorrectLocationConfirmation: false,
                },
            });

            app.routes.changeItem(pageName, pageRoute);
        }
    },
};
